import apiClient from "./index";
import axios from "axios";
import filters from "../../views/common/filters";
/** SSO 관련 API */

// 임시 코드 발급
export const tempCodeIssue = () => {
    return apiClient.get('/sso/tempCodeIssue.json');
};

// 로그인 전파 대상 목록 조회
export const loginSyncTargets = () => {
    return apiClient.get('/sso/loginSyncTargets.json');
};

// SSO 로그인
export const ssoLogin = data => {
    return axios.post(filters.ctxPath('/sso/login.json'), data, { withCredentials: true });
};

// 돌려보낼 주소 허용 여부 확인
export const redirectCheck = url => {
    return apiClient.get('/sso/redirectCheck.json', { params: { url } });
};
